import { api } from '@/api/api-client.config.ts';
import { useMutation } from '@tanstack/react-query';

interface SendPrizeNotificationsBody {
  prize_text_en: string;
  prize_text_lv: string;
  prize_text_et: string;
  prize_text_ru: string;
  prize_text_sk: string;
  contestname_en: string;
  contestname_ru: string;
  contestname_lv: string;
  contestname_et: string;
  contestname_sk: string;

  user_ids: number[];
  pickem_id: number;
  league_id?: number;
  tournament_id?: number;
}

const sendPrizeNotifications = (body: SendPrizeNotificationsBody) =>
  api.post(`/admin/send-prize-notifications`, body);

export const useSendPrizeNotificationsMutation = () => {
  return useMutation({
    mutationKey: ['sendPrizeNotifications'],
    mutationFn: sendPrizeNotifications,
  });
};
